import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../components/InputComponent';
import { CatalogoService } from '../../../service/CatalogoService';
import * as generic from '../../../components/Generico';
import { EmpleadoDatosPersonales as EmpleadoDatosPersonalesModel } from '../../../models/ficha/EmpleadoDatosPersonales';
import { EmpleadoService } from '../../../service/EmpleadoService';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const EmpleadoDatosPersonales = ({ toast, id, permss, catalogos, next, nuevoEmpleado, soloLectura }) => {

    const omodel = new EmpleadoDatosPersonalesModel({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const empleadoService = new EmpleadoService();
    const catalogoService = new CatalogoService();
    const { inDrop, inDropMultiple, inText, inCalendar, inArea } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorPersonal, setEcuadorPersonal] = useState(false);
    const [ciudadesPersonal, setCiudadesPersonal] = useState([]);
    const [ecuadorNac, setEcuadorNac] = useState(false);
    const [esCedula, setEsCedula] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        empleadoService.consultarEmpleado(id ?? 0, 'seccion1').then(res => {
            const cats = catalogos;
            const _emp = res.data.empleado;
            if (!_emp) {
                reset(defaultValues);
                return;
            }
            _emp.fecha = generic.stringToDate(_emp.fecha);
            _emp.fecha_ingreso = generic.stringToDate(_emp.fecha_ingreso);
            _emp.fecha_nacimiento = generic.stringToDate(_emp.fecha_nacimiento);
            setEcuadorNac(_emp.nacionalidad?.cat_id === cats.ecuador_nac?.cat_id);
            setEsCedula(_emp.tipo_identificacion?.cat_id === cats.cedula?.cat_id);
            setEcuador(_emp.pais?.cat_id === cats.ecuador?.cat_id);
            setEcuadorPersonal(_emp.pais_personal?.cat_id === cats.ecuador?.cat_id);
            if (res.data.ciudades) {
                setCiudades(res.data.ciudades);
            }
            if (res.data.ciudades_personal) {
                setCiudadesPersonal(res.data.ciudades_personal);
            }
            if (cats?.grupo?.length > 0) {
                if (_emp.grupo) {
                    _emp.grupo = cats.grupo.filter(item => _emp.grupo.includes(item.cat_id));
                } else {
                    _emp.grupo = null;
                }
            }
            reset(generic.renewValues(_emp, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = 'seccion1';
        data.ec = catalogos?.ecuador;
        data.ecn = catalogos?.ecuador_nac;
        data.casado = catalogos?.casado;
        data.union = catalogos?.union;
        data.grp = catalogos?.grupo?.length ?? 0;
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        data.fecha_ingreso = generic.dateToString(data.fecha_ingreso);
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;

        const request = id == null ? empleadoService.newEmpleado(data) : empleadoService.editarEmpleado(data);
        request.then(res => {
            nuevoEmpleado(res.data); // Si es nuevo, actualiza el id, nemonico y tiene_conyuge, caso contrario solo tiene_conyuge
            generic.funcSuccess(res, toast);
            next(res.data);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePais = (e, esDeclarante) => {
        if (esDeclarante) {
            setEcuador(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia', null);
            setValue('ciudad', null);
            setCiudades([]);
        } else {
            setEcuadorPersonal(e.value?.cat_id === catalogos?.ecuador?.cat_id);
            setValue('provincia_personal', null);
            setValue('ciudad_personal', null);
            setCiudadesPersonal([]);
        }
    }

    const onChangeProvincia = (e, esDeclarante) => {
        if (esDeclarante) {
            setValue('ciudad', null);
            if (!e?.value) { setCiudades([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
        } else {
            setValue('ciudad_personal', null);
            if (!e?.value) { setCiudadesPersonal([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesPersonal(res.data));
        }
    }

    const onChangeTipo = (e) => {
        setEsCedula(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion');
    }

    const onChangeNacionalidad = (e) => {
        setEcuadorNac(e.value?.cat_id === catalogos?.ecuador_nac?.cat_id);
    }

    const tipoDoc = esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || 'Cédula incorrecta';
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('A', 'VINCULACIÓN LABORAL', 'pi pi-briefcase')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {catalogos?.grupo?.length > 0 && inDropMultiple('grupo', catalogos?.grupo, { lab: omodel.optionLabel }, 12)}

                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-map-marker text-primary"></i>
                                LUGAR Y FECHA
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {inCalendar('fecha', {}, 3)}
                    {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: true }, ecuador ? 3 : 4)}
                    {ecuador ? (
                        <>
                            {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: true }, 3)}
                            {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 3)}
                        </>
                    ) : (
                        inText('canton', { icon: 'pi pi-map-marker' }, 5)
                    )}

                    <div className="col-12 mb-3 mt-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-briefcase text-primary"></i>
                                INFORMACIÓN DEL CARGO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {omodel.model.tipo_empleado.table && inDrop('tipo_empleado', catalogos?.tipo_empleado, { lab: omodel.optionLabel }, 3)}
                    {inDrop('tipo_informacion', catalogos?.declaracion, { lab: omodel.optionLabel }, omodel.model.tipo_empleado.table ? 3 : 4)}
                    {inCalendar('fecha_ingreso', {}, omodel.model.tipo_empleado.table ? 3 : 4)}
                    {inText('cargo', { icon: 'pi pi-briefcase' }, omodel.model.tipo_empleado.table ? 3 : 4)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('B', 'DATOS PERSONALES Y DE UBICACIÓN', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('nombres', { icon: 'pi pi-user' }, 3)}
                    {inText('apellidos', { icon: 'pi pi-user' }, 3)}
                    {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 3)}
                    {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}

                    {inDrop('nacionalidad', catalogos?.nacionalidad, { lab: omodel.optionLabel, chn: onChangeNacionalidad }, !ecuadorNac ? 3 : 4)}
                    {!ecuadorNac && inText('tiempo_residencia', { icon: 'pi pi-clock' }, 3)}
                    {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, !ecuadorNac ? 3 : 4)}
                    {inCalendar('fecha_nacimiento', {}, !ecuadorNac ? 3 : 4)}

                    {inDrop('estado_civil', catalogos?.estado_civil, { lab: omodel.optionLabel }, omodel.model.separacion_bienes.table ? 6 : 12)}
                    {omodel.model.separacion_bienes.table && inDrop('separacion_bienes', generic.estadosSiNo, { lab: omodel.optionLabel }, 6)}

                    <div className="col-12 mb-3 mt-4">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-home text-primary"></i>
                                UBICACIÓN Y CONTACTO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {inDrop('pais_personal', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, ecuadorPersonal ? 4 : 6)}
                    {ecuadorPersonal ? (
                        <>
                            {inDrop('provincia_personal', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                            {inDrop('ciudad_personal', ciudadesPersonal, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('canton_personal', { icon: 'pi pi-map-marker' }, 6)
                    )}

                    {inArea('calles', 3, 500, 12)}
                    {inText('correo_personal', { pattern: omodel.pattern, icon: 'pi pi-envelope' }, 4)}
                    {inText('celular', { icon: 'pi pi-mobile' }, 4)}
                    {inText('telefono', { icon: 'pi pi-phone' }, 4)}
                </div>
            </Panel>

            <BottomActionBar onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
